<ngb-alert [type]="'danger'" *ngIf="errorMessage">
  {{ errorMessage }}
</ngb-alert>

<app-spinner *ngIf="isLoading"></app-spinner>

<div class="col col-md-8 col-sm-9 col-xs-12" *ngIf="!isLoading">
  <div class="card">
    <div class="card-header">Editar usuario/a</div>
    <div class="card-body">
      <form (submit)="onSubmit(editForm)" #editForm="ngForm">
        <div class="mb-3">
          <label class="form-label">Nombre:</label>
          <input
            type="text"
            class="form-control"
            name="firstname"
            [ngModel]="user.firstname"
            #firstnameInput="ngModel"
            required
          />
          <p
            class="text-danger p-3 px-0"
            *ngIf="!firstnameInput.pristine && firstnameInput.invalid"
          >
            Por favor, introduzca un nombre válido.
          </p>
        </div>

        <div class="mb-3">
          <label class="form-label">Apellido(s):</label>
          <input
            type="text"
            class="form-control"
            name="surname"
            [ngModel]="user.surname"
            #surnameInput="ngModel"
            required
          />
          <p
            class="text-danger p-3 px-0"
            *ngIf="!surnameInput.pristine && surnameInput.invalid"
          >
            Por favor, introduzca un apellido/s válido.
          </p>
        </div>
        <div class="mb-3">
          <label class="form-label">E-mail:</label>
          <input
            type="email"
            class="form-control"
            name="email"
            [ngModel]="user.email"
            #emailInput="ngModel"
            required
            email
          />
          <p
            class="text-danger p-3 px-0"
            *ngIf="!emailInput.pristine && emailInput.invalid"
          >
            Por favor, introduzca una dirección de e-mail válida.
          </p>
        </div>
        <div class="mb-3" *ngIf="roles">
          <label class="form-label">Rol:</label>
          <select
            class="form-control"
            name="roleID"
            [ngModel]="user.role_id"
            #roleIDInput="ngModel"
          >
            <ng-container *ngFor="let role of roles">
              <ng-container *ngIf="user.role_code == role.role_code">
                <option [value]="role.role_id" selected>
                  {{ role.role_description }}
                </option>
              </ng-container>
              <ng-container *ngIf="user.role_code != role.role_code">
                <option [value]="role.role_id">
                  {{ role.role_description }}
                </option>
              </ng-container>
            </ng-container>
          </select>

          <p class="text-muted text-end p-1 px-0">
            <small
              >Sólo los roles "Administrador/a" y "Editor/a" proporcionan acceso
              a la interfaz de gestión.</small
            >
          </p>
        </div>
        <div class="mb-3">
          <label class="form-label">Política de privacidad aceptada el:</label>
          <input
            type="text"
            class="form-control"
            [value]="user.date_privacy_accepted"
            disabled
          />
        </div>
        <div class="mb-3">
          <label class="form-label">Última conexión:</label>
          <input
            type="text"
            class="form-control"
            [value]="user.date_last_login || '- Nunca - '"
            disabled
          />
        </div>
        <button
          *ngIf="!isLoading"
          type="submit"
          class="btn btn-primary"
          [disabled]="editForm.invalid && emailInput.invalid"
        >
          Confirmar
        </button>
        <p *ngIf="isLoading">Cargando...</p>
      </form>
    </div>
  </div>
</div>
